import { render, staticRenderFns } from "./DisciplinePortfolioRegister.vue?vue&type=template&id=a07f47b8"
import script from "./DisciplinePortfolioRegister.vue?vue&type=script&lang=js"
export * from "./DisciplinePortfolioRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a07f47b8')) {
      api.createRecord('a07f47b8', component.options)
    } else {
      api.reload('a07f47b8', component.options)
    }
    module.hot.accept("./DisciplinePortfolioRegister.vue?vue&type=template&id=a07f47b8", function () {
      api.rerender('a07f47b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/grid/DisciplinePortfolioRegister.vue"
export default component.exports